import { SSO_VALIDATE_PATH } from '../constants';

export function saveLoginRedirectFrom({
  pathname,
  search = '',
}) {
  if (pathname !== SSO_VALIDATE_PATH) {
    memoryDB.DECISIV__redirectedToLoginFrom = `${pathname}${search}`;
  }
}

export function consumeLoginRedirectFrom() {
  const redirectPath = memoryDB.DECISIV__redirectedToLoginFrom || '/';
  memoryDB.removeItem('DECISIV__redirectedToLoginFrom');
  return redirectPath;
}



// WEBPACK FOOTER //
// ./features/authentication/utils/redirects.js